export default Object.freeze({
  UnSet: 0,
  ReasonToTry: 1,
  ReasonToDeny: 2,
  ContractInformationIsCorrect: 3,
  ContractInformationIsNotCorrect: 4,
  CancellationReason: 5,
  ReasonForSupplierChange: 6,
  ReasonForChangeStatusToNew: 7,
  CancellationByProvider: 9,
  DischargedService: 10,
  Absenteeism: 11,
  ProviderChange: 12,
  ContractBreach: 13,
});
